import React, { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  CircularProgress,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { LoginPage } from "../../pages/login";
import { HeaderComponent } from "../../components/Header/index";
import { product } from "../../api/paquetes";

export const HomePage: React.FC<{}> = () => {
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const [openRestoreModal, setOpenRestoreModal] = useState(false);
  const [paqueteId, setPaqueteId] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<{
    type: "success" | "error";
    message: string;
  } | null>(null);

  const handleOpenRestoreModal = () => {
    setOpenRestoreModal(true);
    setPaqueteId("");
    setResult(null);
  };

  const handleCloseRestoreModal = () => {
    setOpenRestoreModal(false);
    setPaqueteId("");
    setResult(null);
  };

  const handleRestoreBudget = async () => {
    if (!paqueteId) {
      setResult({
        type: "error",
        message: "Por favor ingrese un número de paquete",
      });
      return;
    }
    setLoading(true);
    setResult(null);
    try {
      const response = await product.restoreBudget(Number(paqueteId));
      setResult({
        type: "success",
        message: response.data?.message || "Paquete recuperado exitosamente",
      });
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Error al recuperar el paquete";
      setResult({ type: "error", message: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  if (!isLoggedIn) {
    return <LoginPage />;
  }
  return (
    <Container maxWidth="xl">
      <HeaderComponent title="Turismo Vittorio" description="Administración" />
      <Grid 
        container 
        spacing={6} 
        mt={4} 
        alignItems="stretch"
      >
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              transition: "0.3s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: 6,
                cursor: "pointer",
              },
            }}
          >
            <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
              <Typography variant="h5" component="div" gutterBottom>
                Proveedores
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 5, flexGrow: 1 }}
              >
                Aquí puedes administrar los proveedores, los productos comprados
                para estos y los pagos relacionados a cada uno de ellos.
              </Typography>
              <Button
                component={NavLink}
                to="/proveedores"
                variant="contained"
                sx={{ mt: "auto" }}
              >
                Ver Proveedores
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              transition: "0.3s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: 6,
                cursor: "pointer",
              },
            }}
          >
            <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
              <Typography variant="h5" component="div" gutterBottom>
                Pagos
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 5, flexGrow: 1 }}
              >
                En esta seccion puedes ver todos los pagos cargados, para todos
                los proveedores. Podras editar y eiminar pagos existentes
              </Typography>
              <Button
                component={NavLink}
                to="/pagos"
                variant="contained"
                sx={{ mt: "auto" }}
              >
                Ver Pagos
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              transition: "0.3s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: 6,
                cursor: "pointer",
              },
            }}
          >
            <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
              <Typography variant="h5" component="div" gutterBottom>
                Paquetes Individuales
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 5, flexGrow: 1 }}
              >
                En esta seccion puedes administrar presupuestos y paquetes.
              </Typography>
              <Button
                component={NavLink}
                to="/paquetes"
                variant="contained"
                sx={{ mt: "auto" }}
              >
                Ver Paquetes
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              transition: "0.3s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: 6,
                cursor: "pointer",
              },
            }}
          >
            <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
              <Typography variant="h5" component="div" gutterBottom>
                Paquetes Grupales [PRUEBAS]
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 5, flexGrow: 1 }}
              >
                En esta seccion puedes administrar presupuestos y paquetes grupales para quinces, egresados, educativos, eventos y otros
              </Typography>
              <Button
                component={NavLink}
                to="/paquetes-grupales"
                variant="contained"
                sx={{ mt: "auto" }}
              >
                Ver Paquetes
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              transition: "0.3s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: 6,
                cursor: "pointer",
              },
            }}
            onClick={handleOpenRestoreModal}
          >
            <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
              <Typography variant="h5" component="div" gutterBottom>
                Recuperación de Paquetes
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 5, flexGrow: 1 }}
              >
                En esta sección puedes recuperar paquetes eliminados ingresando
                su número de identificación.
              </Typography>
              <Button variant="contained" sx={{ mt: "auto" }}>
                Recuperar Paquete
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Modal de Recuperación de Paquetes */}
      <Dialog
        open={openRestoreModal}
        onClose={handleCloseRestoreModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Recuperación de Paquetes</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Número de Paquete"
            type="number"
            fullWidth
            variant="outlined"
            value={paqueteId}
            onChange={(e) => setPaqueteId(e.target.value)}
            sx={{ mt: 2 }}
          />
          {result && (
            <Alert severity={result.type} sx={{ mt: 2 }}>
              {result.message}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRestoreModal} disabled={loading}>
            Cancelar
          </Button>
          <Button
            onClick={handleRestoreBudget}
            variant="contained"
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {loading ? "Procesando..." : "Recuperar"}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};
